import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import history from "../../history";
import { getZone } from "../../actions/zone";
import {
  Table,
  Input,
  Button,
  PageHeader,
  Popconfirm,
  Breadcrumb,
  Tag,
} from "antd";
import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusCircleFilled,
  SearchOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { Content } from "antd/lib/layout/layout";

const Zone = ({ getZone }) => {
  const [data, setData] = useState([]);

  useEffect(async () => {
    window.scrollTo(0, 0)
    const res = await getZone();
    setData(res);
  }, []);

  const searchColumns = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => {
      return (
        <div style={{ padding: 8 }}>
          <Input
            autoFocus
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            onPressEnter={() => {
              confirm();
            }}
            onBlur={() => {
              confirm();
            }}
            style={{ marginBottom: 8, display: "block" }}
          ></Input>
          <Button
            onClick={() => {
              confirm();
            }}
            type="primary"
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          &nbsp;
          <Button
            onClick={() => {
              clearFilters();
            }}
            size="small"
            type="danger"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </div>
      );
    },
    filterIcon: () => {
      return <SearchOutlined />;
    },
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
  });
  const columns = [
    {
      title: "Zone Name",
      dataIndex: "name",
      key: "name",
      width: "15%",
      ...searchColumns("name"),
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: "15%",
      ...searchColumns("city"),
    },
    {
      title: "Sub City",
      dataIndex: "sub_city",
      key: "sub_city",
      width: "10%",
      ...searchColumns("sub_city"),
    },
    {
      title: "Thana",
      dataIndex: "id",
      key: "id",
      width: "10%",
      ...searchColumns("id"),
    },
    {
      title: "Warehouse",
      dataIndex: "warehouse_id",
      key: "warehouse_id",
      width: "25%",
      ...searchColumns("warehouse_id"),
    },
  ];
  const createData = (name, city, sub_city, id, warehouse_id) => {
    return { name, city, sub_city, id, warehouse_id };
  };

  const rows = [
    data
      ? data?.map((zone) =>
          createData(
            zone?.name,
            zone?.city,
            zone?.sub_city,
            zone?.thana.map((subzone) => subzone?.name),
            [
              zone?.warehouse?.warehouse_id,
              zone?.warehouse?.name,
              zone?.warehouse?.address,
            ]
          )
        )
      : "",
  ];

  const Pageheader = (
    <PageHeader
      ghost={false}
      onBack={() => window.history.back()}
      title="Zone List"
      subTitle="Zone Management"
    ></PageHeader>
  );

  return (
    <Content>
      {Pageheader}
      <br></br>
      <Table
        columns={columns}
        dataSource={rows[0]}
        scroll={{ x: 1000 }}
        sticky
      />
    </Content>
  );
};

export default connect(null, {
  getZone,
})(Zone);
